export const GENERAL_ERROR = 'Oops… it looks like there was an issue';
export const GENERAL_ERROR_HEADING = "That's unexpected!";
export const GENERAL_ERROR_CAPTION =
  "Try refreshing, or use the main menu to navigate to a new page. We've logged an error and are working to fix it.";
export const TEST_ID = 'general-error';
export const ERROR_BOUNDARY = 'ERROR_BOUNDARY';
